import { Typography } from 'antd';
import React, { FC } from 'react';
import {
  Container, Footer, FooterLogo, FooterText, Logo, MainSection, TextSection,
} from './styles';
import { FONT } from '../../../styles/color';

const { Text } = Typography;

export const AmplarThanksPage: FC = () => (
  // useEffect(() => {
  //   analytics.logPageViewEvent(BOOKING_RESULT, {
  //     site: SITE_NAME,
  //     page_path: pathname,
  //   });
  // }, [pathname]);
  <Container>
    <header>
      <Logo alt="logo" width="70%" height="68px" src="/amplar-logo.svg" />
    </header>

    <Typography.Title
      level={2}
      style={{
        marginBottom: '70px', fontWeight: 800, color: FONT,
      }}
    >
      Referral Confirmation
    </Typography.Title>

    <MainSection>
      <Typography.Title
        level={3}
        style={{
          marginBottom: '70px', fontWeight: 800, color: FONT,
        }}
      >
        Thank you for taking the time to provide us with the referral details.
      </Typography.Title>
    </MainSection>

    <TextSection>
      <Text>
        If you need to contact us prior or after your referral, please find our contact details:
        <br />
        Phone: (02) 8935 6448
        <br />
        Email:
        {' '}
        <a
          style={{ textDecoration: 'underline' }}
          href="mailto:amplarhealthpsychology@telecare.com.au"
        >
          amplarhealthpsychology@telecare.com.au
        </a>
      </Text>
    </TextSection>

    <Footer>
      <Typography.Text style={{
        marginTop: '50px', display: 'block', textDecoration: 'underline', fontSize: '18px',
      }}
      >
        <a
          href="https://virtualpsychology.amplarhealth.com.au/"
        >
          Back to Home
        </a>
      </Typography.Text>
      <a href="https://www.telecare.com.au/" target="_blank" rel="noopener noreferrer">
        <FooterLogo src="/telecare-logo.svg" alt="Telecare Logo" />
      </a>
      <FooterText>Service powered by Telecare</FooterText>
    </Footer>
  </Container>
);
